import React from 'react';
import Dropzone from 'react-dropzone';
import FadeErrorMessage from '../util/FadeOutErrorMessage';

export default class UploadAttachments extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            duplicates: 0,
            rejectedFiles: 0,
        };

        this.onFileDrop = this.onFileDrop.bind(this);
        this.removeFile = this.removeFile.bind(this);
        this.dropRejected = this.dropRejected.bind(this);
    }

    mounted = false;

    onFileDrop(acceptedFiles) {
        //to avoid memory leaks
        let files = [...this.props.files];
        let duplicates = 0;
        acceptedFiles.forEach(newFile => {
            if (files.filter(f => f.name === newFile.name && f.lastModified === newFile.lastModified && f.size === newFile.size).length > 0) {
                duplicates++;
            } else {
                files.push(newFile);
            }
            if (duplicates) {
                this.setState({ duplicates }, () => {
                    setTimeout(() => {
                        if (this.refs.dropzone) {
                            this.setState({ duplicates: 0 })
                        }
                    }, 5000);
                });
            }

            window.URL.revokeObjectURL(newFile.preview)
        });

        this.props.onChange(this.props.name, files);
    }

    dropRejected(rejectedFiles) {
        this.setState({ rejectedFiles: rejectedFiles.length }, () => {
            setTimeout(() => {
                if (this.refs.dropzone) {
                    this.setState({ rejectedFiles: 0 })
                }
            }, 5000);
        });
    }

    removeFile(file) {
        let files = [...this.props.files];
        var index = files.indexOf(file);
        if (index > -1) files.splice(index, 1);
        this.props.onChange(this.props.name, files);
    }


    render() {
        return (
            <div className="upload-box-container">
                <div className="column-half column-half-left">
                    <label className="input-label">Uploads</label>
                    <Dropzone ref="dropzone" className="upload-box"
                        accept={'application/pdf,text/html,image/png,image/jpeg,image/tiff,image/gif,image/bmp,application/vnd.openxmlformats-officedocument.wordprocessingml.document,.docx'}
                        onDropRejected={this.dropRejected} disablePreview={true}
                        onDropAccepted={this.onFileDrop} multiple={true} maxSize={20000000}>
                        <p className="accent-text"><i className="icon ion-ios-cloud-upload-outline" />Drop files here
                            or <br /> click to <span className="accent-text2 block">Upload Attachment</span></p>
                    </Dropzone>
                    <div>
                        <FadeErrorMessage message="Can not upload duplicate file(s)" show={this.state.duplicates} />
                        <FadeErrorMessage
                            message="Incompatible file format or size."
                            show={this.state.rejectedFiles} />
                    </div>
                </div>
                <div className="column-half">
                    {(this.props.files && this.props.files.length > 0) && <div>
                        <label className="input-label">Files to be Uploaded</label>
                        <ul>
                            {this.props.files.map(f => (
                                <li key={f.name}>
                                    <i className="icon ion-document icon-left middle" />
                                    <label className="small-text">{f.name}</label>
                                    <i className="icon ion-ios-close-outline trash-hover icon-right middle"
                                        onClick={this.removeFile.bind(this, f)} />
                                </li>
                            ))}
                        </ul>
                    </div>}
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/commonComponents/shared/UploadAttachments.jsx